import { Component } from '@angular/core';
import { NavController, NavParams, MenuController, AlertController } from 'ionic-angular';

import { TranslateService } from 'ng2-translate';

import { EmployeeDetailsPage } from './employee-details/employee-details';
import { IEmployee, Employee } from '../../model/top.model';

import { EmployeeData } from '../../providers/employee-data';
import { TimeRegistrationData } from '../../providers/time-registration-data';

import { EditMode, Jobrole } from '../../enums/enums'

@Component({
  selector: 'page-employees',
  templateUrl: 'employees.html'
})
export class EmployeesPage {
  private filterName: string;
  private employees: Array<IEmployee>;
  loggedInEmployee: IEmployee;
  Jobrole = Jobrole;
  showNotActive: boolean;

  constructor(public navCtrl: NavController, public navParams: NavParams, public menuCtrl: MenuController, private alertCtrl: AlertController, private employeeData: EmployeeData, private timeRegistrationData: TimeRegistrationData, private translate: TranslateService) {
    menuCtrl.enable(true);
    this.employees = [];
    this.filterName = "";
    this.employeeData.getEmployee(this.employeeData.loggedInEmployeeId).then((loggedInEmployee: IEmployee) => {
      this.loggedInEmployee = loggedInEmployee;
    });
  }
  ionViewDidEnter() {
    this.employeeData.getEmployeesBasic().then((result: Array<IEmployee>) => {
      this.employees = result;
      this.filterEmployees();
    });
  }

  employeeTapped(event, employee) {
    this.navCtrl.push(EmployeeDetailsPage, {
      employee: employee
    });
  }

  filterEmployees() {
    this.employees = this.employeeData.filterEmployees(this.filterName);
    // this.employees.sort(function (a, b) {
    //   if (a.last_name < b.last_name) return -1;
    //   if (a.last_name > b.last_name) return 1;
    //   if (a.first_name < b.first_name) return -1;
    //   if (a.first_name > b.first_name) return 1;
    //   return 0;
    // });
  }

  addEmployee() {
    this.navCtrl.push(EmployeeDetailsPage, {
      editMode: EditMode.new
    });
  }

  deleteEmployee(employee: IEmployee) {
    // this.timeRegistrationData.findEmployeeTimeRegistrations(employee.employee_id, true, null, null).then(timeRegistrations => {
    //   if (timeRegistrations.length > 0) {
    //     let alert = this.alertCtrl.create({
    //       title: 'Kan niet verwijderen',
    //       subTitle: 'Deze medewerker heeft uren geregistreerd',
    //       cssClass: 'tv-delete-alert',
    //       buttons: [{
    //         text: this.translate.instant('OK')
    //       }]
    //     });
    //     alert.present();
    //   } else {
    let alert = this.alertCtrl.create({
      title: this.translate.instant('DELETE') + '?',
      subTitle: this.translate.instant('ARE_YOU SURE_DELETE', { value: '"' + employee.first_name + ' ' + employee.last_name + '"' }) + '?',
      cssClass: 'tv-delete-alert',
      buttons: [{
        text: this.translate.instant('NO')
      },
      {
        text: this.translate.instant('YES'),
        handler: data => {
          this.employeeData.deleteEmployee(employee).then((res: any) => {
            this.employeeData.getEmployees(false).then((result: Array<IEmployee>) => {
              this.employees = result;
              this.filterEmployees();
            });
          });
        }
      }]
    });
    alert.present();
    //   }
    // });
  }
  resetLoginEmployee(employee: IEmployee) {
    let alert = this.alertCtrl.create({
      title: 'Wachtwoord resetten',
      subTitle: 'Weet je zeker dat je het wachtwoord van ' + employee.first_name + ' ' + (employee.middle_name ? employee.middle_name + ' ' : '') + employee.last_name + ' wilt resetten?',
      cssClass: 'tv-delete-alert',
      buttons: [{
        text: this.translate.instant('NO')
      },
      {
        text: this.translate.instant('YES'),
        handler: data => {
          this.employeeData.resetLoginEmployee(employee).then((result: Array<IEmployee>) => {
            // console.log(result);
          });
        }
      }]
    });
    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/employees/employees.ts